import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { usePrefs } from '../stores/prefs';
import de from './de';
import en, { type Translation } from './en';
import es from './es';
import fr from './fr';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: { translation: Translation };
  }
}

// All languages are bundled (they're small) so switching works offline.
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
  },
  lng: usePrefs.getState().language,
  fallbackLng: 'en',
  initAsync: false,
  interpolation: { escapeValue: false },
});

function applyLanguage(language: string) {
  document.documentElement.lang = language;
  if (i18n.language !== language) void i18n.changeLanguage(language);
}

applyLanguage(usePrefs.getState().language);
usePrefs.subscribe((state) => applyLanguage(state.language));

export default i18n;
